import type { EarningStatus, TaskTag } from '../../types';
import { statusLabel, statusTagClass, taskTagClass, taskTagLabel } from '../../utils';

interface TaskBadgeProps {
  tag: TaskTag;
}

export function TaskBadge({ tag }: TaskBadgeProps) {
  const label = taskTagLabel(tag);
  if (!label) return null;

  return <span className={`tag ${taskTagClass(tag)}`}>{label}</span>;
}

interface StatusBadgeProps {
  status: EarningStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return <span className={`tag ${statusTagClass(status)}`}>{statusLabel(status)}</span>;
}
